
import { useState, useEffect } from 'react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Entry Food Tunnel Background */}
      <div className="absolute inset-0">
        <img 
          src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80"
          alt="Entry Food Tunnel at Aroha Farm"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
      </div>

      {/* Floating Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-4 sm:left-10 w-3 h-3 sm:w-4 sm:h-4 bg-green-400/30 rounded-full animate-pulse"></div>
        <div className="absolute top-32 sm:top-40 right-8 sm:right-20 w-4 h-4 sm:w-6 sm:h-6 bg-yellow-400/30 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-32 sm:bottom-40 left-8 sm:left-20 w-4 h-4 sm:w-5 sm:h-5 bg-blue-400/30 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute bottom-20 right-4 sm:right-10 w-3 h-3 bg-pink-400/30 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto pt-16 sm:pt-20">
        <div className={`transform transition-all duration-1500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
            Welcome to{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-300 block sm:inline" style={{ fontFamily: 'Pacifico, serif' }}>
              Aroha Farm
            </span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light mb-3 sm:mb-4 text-green-100">
            Nature, Tradition, and Community
          </p>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-8 sm:mb-12 text-gray-200 max-w-4xl mx-auto leading-relaxed">
            Experience organic living, natural farming, and the joy of growing together through our Entry Food Tunnel and sustainable practices
          </p>
        </div>

        <div className={`flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center transform transition-all duration-1500 delay-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          <button className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-6 sm:px-8 lg:px-10 py-3 sm:py-4 lg:py-5 rounded-full text-base sm:text-lg lg:text-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer">
            Explore Experiences
          </button>
          <button className="border-2 border-white text-white hover:bg-white hover:text-green-600 px-6 sm:px-8 lg:px-10 py-3 sm:py-4 lg:py-5 rounded-full text-base sm:text-lg lg:text-xl font-semibold transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer">
            Plan Your Visit
          </button>
        </div>

        {/* Entry Food Tunnel Feature */}
        <div className={`mt-12 sm:mt-16 transform transition-all duration-1500 delay-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto">
            <div className="flex flex-col sm:flex-row items-center justify-center mb-3 sm:mb-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-500/20 rounded-full flex items-center justify-center mb-3 sm:mb-0 sm:mr-4">
                <i className="ri-road-map-line text-xl sm:text-2xl text-green-300"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white text-center sm:text-left">Entry Food Tunnel Experience</h3>
            </div>
            <p className="text-sm sm:text-base lg:text-lg text-gray-200 leading-relaxed">
              Begin your journey through our unique Entry Food Tunnel, where nature welcomes you with an immersive pathway surrounded by growing plants and fresh produce
            </p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="w-5 h-8 sm:w-6 sm:h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-2 sm:h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
        <p className="text-xs sm:text-sm mt-2 text-gray-300">Scroll to explore</p>
      </div>
    </section>
  );
};

export default Hero;
